'use client';
import Link from "next/link";
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';

export default function NavBar() {
  const pathname = usePathname();
  const isLoginPage = pathname === '/login';
  const { data: session } = useSession();
  const USER = session?.user?.username || "";

  const mainNavItems = [
    { href: '/', label: USER },
    { href: '', label: "|" },
  ];

  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-primary shadow-sm ps-4 pe-4">
      <div className={`container-xxl justify-content-center ${!isLoginPage ? 'justify-content-sm-between' : ''} align-items-center`}>

        <Link
          href="/"
          className="navbar-brand fw-bold ms-1"
        >
          <div className='gap-2 d-flex align-items-center'>
            <img src="/kee-icon.svg" alt="Keeneland" />
            <img src="/Rectangle-1.svg" alt="|" />
            <span className='fw-normal'> Health Document Parser</span>
          </div>
        </Link>

        {!isLoginPage && (
          <>
            <ul className="navbar-nav d-none d-md-flex">
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle border-0 bg-transparent m-0 text-white"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ textTransform: "none" }}
                >
                  Add Documents
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link href="/add-new" className="dropdown-item">Add + Parse Document</Link>
                  </li>
                  <li>
                    <Link href="/add-new-non-parsed" className="dropdown-item">Add Documents</Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link href="/review-documents" className="nav-link text-white">Review Documents</Link>
              </li>
              <li className="nav-item">
                <Link href="/select-sale" className="nav-link text-white">View Horse Statuses</Link>
              </li>
            </ul>

          <div className="" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              {mainNavItems.map((item) => (
                <li key={item.href + item.label} className="nav-item">
                  <Link
                    href={item.href}
                    className={`nav-link active ${item.label === '|' ? 'd-none d-md-block' : ''} gap-2 d-flex align-items-center justify-content-center h-100`}
                  >
                    {item.label === USER
                      ? <img style={{ width: "28px", height: "28px" }} src="/account-circle.svg" alt="Account Photo" />
                      : null}
                    {item.label}
                  </Link>
                </li>
              ))}
              <li className="nav-item">
                {/* Deliberately a plain <a>, not next/link: /api/auth/logout is a route handler
                    that signs the user out, so it needs a full browser request — and <Link>
                    would prefetch it, which could log the user out just by rendering the nav. */}
                {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
                <a href="/api/auth/logout" className="nav-link active gap-2 d-flex align-items-center justify-content-center h-100">Logout</a>
              </li>
            </ul>
          </div>
          </>
        )}
      </div>
    </nav>
  );
}